import React from "react";
import LegalShell, { Section } from "@/pages/LegalShell";

export default function VerificationsPage() {
    return (
        <LegalShell
            overline="Vérifications"
            title="Ce que nous contrôlons — vraiment."
            subtitle="Renforteo ne publie aucun profil qui n'a pas passé un contrôle documentaire. Voici précisément les pièces demandées, à quoi elles servent, et ce que nous ne faisons pas."
        >
            <Section title="Contrôles systématiques" id="systematiques">
                <p>Chaque candidat doit fournir, avant validation de son profil :</p>
                <ul className="list-disc pl-6 space-y-1.5">
                    <li><b>Numéro de SIRET</b> valide (14 chiffres, vérifié à l'inscription)</li>
                    <li><b>Extrait KBIS</b> ou <b>Fiche INSEE</b> (auto-entrepreneur / société)</li>
                    <li><b>Pièce d'identité</b> (carte nationale ou passeport en cours de validité)</li>
                    <li><b>Justificatif de domicile</b> de moins de trois mois</li>
                    <li><b>RIB / IBAN</b> au nom du titulaire du compte Renforteo</li>
                </ul>
                <p>
                    Ces documents ne sont jamais exposés publiquement. Ils sont stockés de manière
                    chiffrée et ne sont accessibles qu'à notre équipe de vérification et, pour les
                    documents strictement nécessaires à la mission, au client qui a sélectionné
                    le candidat.
                </p>
            </Section>

            <Section title="Contrôles spécifiques par métier" id="specifiques">
                <ul className="list-disc pl-6 space-y-1.5">
                    <li><b>Métiers de conduite / livraison</b> — permis de conduire correspondant à la catégorie du véhicule</li>
                    <li><b>Métiers de bouche / hygiène</b> — diplômes ou attestations HACCP le cas échéant</li>
                    <li><b>Métiers de livraison-montage</b> — expérience assemblage et outillage personnel</li>
                </ul>
            </Section>

            <Section title="Badges vérifiés" id="badges">
                <p>
                    Lorsqu'un document est validé, un <b>badge vérifié</b> apparaît sur le profil
                    (identité, SIRET, permis, langues, HACCP…). Un badge ne s'affiche que lorsque
                    la pièce correspondante est effectivement présente <i>et</i> validée par notre
                    équipe. Aucun badge auto-déclaratif ne s'affiche.
                </p>
            </Section>

            <Section title="Ce que Renforteo ne fait pas" id="limites">
                <p>
                    Par souci de transparence, voici ce que <b>Renforteo ne prétend pas</b> faire :
                </p>
                <ul className="list-disc pl-6 space-y-1.5">
                    <li>
                        Nous ne réalisons pas d'enquête judiciaire ou de vérification de casier judiciaire.
                    </li>
                    <li>
                        Aucune couverture d'assurance responsabilité civile n'est fournie par
                        Renforteo. Chaque professionnel indépendant doit disposer de sa propre
                        RC pro / RC exploitation.
                    </li>
                    <li>
                        Renforteo n'est ni employeur, ni agence de placement au sens du Code du
                        travail. Tous les prestataires sont des <b>auto-entrepreneurs /
                        indépendants immatriculés</b> qui interviennent pour leur propre compte.
                        Le client ne prend en charge <b>aucune déclaration sociale ni charge
                        patronale</b> — le prestataire facture en direct et gère seul sa
                        fiscalité et ses cotisations.
                    </li>
                </ul>
            </Section>

            <Section title="Métiers exclus du champ de la plateforme" id="exclusions">
                <p>
                    Certains métiers sont incompatibles avec le statut d'auto-entrepreneur en droit
                    français ou nécessitent des autorisations spécifiques que Renforteo n'a pas obtenues
                    à ce jour. Ces métiers ne sont donc pas proposés sur la plateforme :
                </p>
                <ul className="list-disc pl-6 space-y-1.5">
                    <li>
                        <b>Sécurité privée (CNAPS)</b> — Renforteo <b>ne commercialise pas</b> de
                        prestations de sécurité privée réglementées par le Conseil National des
                        Activités Privées de Sécurité (art. L611-2 du Code de la sécurité intérieure).
                        Cette activité impose à toute entreprise proposant, y compris par sous-traitance,
                        des prestations de sécurité privée d'être elle-même autorisée par le CNAPS.
                        Nous ferons évoluer notre offre après obtention des autorisations nécessaires.
                    </li>
                    <li>
                        <b>Mannequinat / modèle</b> — le Code du travail (art. L7123-2 et
                        suivants) impose une présomption de salariat pour les mannequins. Ces
                        prestations doivent obligatoirement passer par une agence de mannequins
                        agréée.
                    </li>
                    <li>
                        Toute activité qui, par sa nature récurrente ou son lien de subordination,
                        pourrait requalifier la relation en contrat de travail (jurisprudence
                        Cour de cassation).
                    </li>
                </ul>
            </Section>

            <Section title="Métiers réglementés proposés" id="reglementes">
                <p>Les métiers suivants sont ouverts mais nécessitent une pièce spécifique :</p>
                <ul className="list-disc pl-6 space-y-1.5">
                    <li><b>Chef de cuisine / cuisinier</b> — formation Hygiène Alimentaire (HACCP) exigée par la majorité des clients ; l'obligation légale porte sur l'établissement (donneur d'ordre)</li>
                    <li><b>Livreur / livreur-monteur &gt; 3,5 t</b> — capacité de transport léger de marchandises</li>
                </ul>
            </Section>
        </LegalShell>
    );
}
